import { createMarkup } from '@hub/libs/utils';
import { fixMarkupLinks } from '@hub/libs/links.helper';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import { getLocale } from '@hub/libs/constants';

export interface ProductUspProps {
  usp: string;
  removeLinks?: boolean;
  singleUsp?: boolean;
}

export const ProductUsp = ({ usp, removeLinks, singleUsp }: ProductUspProps) => {
  const router = useRouter();
  const locale = getLocale(router);
  // remove empty li tags, see COM-975
  let actualUsp = usp && typeof usp === 'string' ? usp.replace('<li></li>', '') : '';

  if (removeLinks) {
    actualUsp = actualUsp.replace(/<(?:\/a\s*|a\s+[^>]*)>/gim, '');
  }

  return (
    <div className={classNames(!singleUsp && 'ml-8')}>
      {/* used to style the ul/li coming from ct as a string in usp */}
      <style jsx>{`
        div > :global(ul) {
          list-style-type: disc;
        }

        div > :global(ul > li) {
          padding-bottom: 0.4rem;
        }

        div > :global(ul > li > a) {
          color: #f07d00;
        }

        div > :global(ul > li > a:hover) {
          color: #a45500;
        }
      `}</style>
      <div dangerouslySetInnerHTML={createMarkup(fixMarkupLinks(actualUsp, locale))} />
    </div>
  );
};
